import PropTypes from 'prop-types';
import React from 'react';

import { Meta } from '$partials/global';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const CheatSheet = () => {
    return (
        <>
            <Meta title='Phoenix Court' />
            <main
                className='bg-[salmon] pt-60 min-h-screen relative'
                id='main-content'>
                {/* Side track */}
                <div className='layout-container-padding-right flex flex-wrap max-w-container rounded-md h-screen top-0 fixed z-0 select-none pointer-events-none'>
                    <div className='w-sidebar sidebar-border'>
                    </div>
                </div>

                {/* Default layout, no sidebar */}
                <div className='layout-container'>
                    <div className='flex flex-wrap layout-negative-margin'>
                        {/* Column 1 */}
                        <div className='w-6/12 layout-item-padding'>
                            <p className='type-style-7'>Default, no sidebar</p>
                            <p className='type-style-1'>
                                {'Hello world!'}
                            </p>
                        </div>
                        {/* Column 2 */}
                        <div className='w-8/12 layout-item-padding'>
                            <p className='type-style-3'>
                                {'Lorem ipsum dolor sit amet consectetur adipisicing elit.'}
                            </p>
                        </div>
                    </div>
                </div>

                {/* Spacer */}
                <div className='mt-60'/>

                {/* With sidebar */}
                <div className='layout-container-padding-right flex flex-wrap max-w-container bg-white py-60 rounded-md'>
                    {/* Left Sidebar */}
                    <div className='w-sidebar'>
                        <div className='flex flex-col items-center'>
                            <p className='type-style-8 inline-block align-middle rotate-180 writing-mode-vertical-rl'>
                                {'Our Funds lorem ipsum more more more'}
                            </p>
                            <button
                                className='flex-shrink-0 bg-grey rounded-xl mt-30 p-5'
                                type='button'>
                                {'←'}
                            </button>
                            <button
                                className='flex-shrink-0 bg-grey rounded-xl mt-5 p-5'
                                type='button'>
                                {'→'}
                            </button>
                        </div>
                    </div>

                    {/* Main content */}
                    <div className='flex-1 flex flex-wrap self-start layout-negative-margin'>
                        {/* Column 1 */}
                        <div className='w-6/12 layout-item-padding'>
                            <p className='type-style-7'>With sidebar</p>
                            <p className='type-style-1'>
                                {'Hello world!'}
                            </p>
                        </div>
                        {/* Column 2 */}
                        <div className='w-8/12 layout-item-padding'>
                            <p className='type-style-3'>
                                {'Lorem ipsum dolor sit amet consectetur adipisicing elit.'}
                            </p>
                        </div>
                    </div>
                </div>
            </main>
        </>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

const propTypes = {
};

CheatSheet.propTypes = propTypes;

export default CheatSheet;
